export default "__VITE_ASSET__6ff635c7__"